import {useAuth} from '@clerk/react'
import {LayoutSplashScreen} from '../../_metronic/layout/core'
import {Navigate, Outlet} from 'react-router-dom'

const PublicOnly = () => {
  const {isLoaded, isSignedIn} = useAuth()

  if (!isLoaded) {
    return <LayoutSplashScreen />
  }

  if (isSignedIn) {
    return <Navigate to='/dashboard' replace />
  }

  return <Outlet />
}

export default PublicOnly
